import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 25,
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "18pt",
    lineHeight: "26pt",
    fontFamily: theme.fontFamily,
    padding: "0 50px",
    // fontWeight: "bold" as "bold",
    // paddingBottom: 10,
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    padding: "20px 0",
  },
};
